import type ApplicationController from '@aha-app/mvc';
import { ControlledComponent } from '@aha-app/mvc';
import { type Constructor } from 'javascripts/shared-types';
import React from 'react';
import { createRoot } from 'react-dom/client';

const container = Symbol('container');

export interface IHasGlobalContainer {
  renderGlobalContainer(): void;
  unmountGlobalContainer(): void;
}

function HasGlobalContainer(AppComponent: React.FC) {
  return function <T extends Constructor<ApplicationController<any, any, any>>>(
    originalClass: T
  ) {
    return class extends originalClass implements IHasGlobalContainer {
      renderGlobalContainer() {
        this.unmountGlobalContainer();

        const el = document.createElement('div');
        document.body.append(el);
        this[container] = createRoot(el);

        this[container].render(
          <ControlledComponent controller={this}>
            <AppComponent />
          </ControlledComponent>
        );
      }

      unmountGlobalContainer() {
        if (this[container]) {
          try {
            this[container].unmount();
          } catch (ex) {}

          this[container] = null;
        }
      }
    };
  };
}

export default HasGlobalContainer;
